import styled, { css } from 'styled-components';

import { BaseStyle, Button } from '@nhl/nhl-breakaway-ui';

import { Control, SkinnySlideBase } from '../baseCarousel/styles';

import { DraftLink } from './components/draftLinks/styles';

export const DRAFT_PICK_SLIDE_HEIGHT = 95;
export const SKINNY_SLIDE_WIDTH = 48;

export const DraftMiniTrackerWrapper = styled.div`
    width: 100%;
    height: 182px;
    position: relative;
    background-color: ${({ theme }) => theme.Surface.primary};

    ${BaseStyle.Mixins.screenSizes.smallerThanMedium} {
        width: 100vw;
        height: 227px;
        left: -16px;
    }

    * {
        color: ${({ theme }) => theme.Text.primary};
    }
`;

export const RoundRow = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
`;

export const CurrentPickButton = styled(Button)`
    ${BaseStyle.Mixins.fontStyles.ui['12b']}

    cursor: pointer;
    padding: 0;
`;

export const CarouselRow = styled.div`
    display: flex;
    flex-direction: row;
    padding-bottom: 8px;

    .alice-carousel__stage {
        .alice-carousel__stage-item {
            border: none;

            &:last-child {
                border: none;
            }
        }
    }
`;

export const SkinnySlide = styled(SkinnySlideBase)<{ $isLeftControl: boolean }>`
    position: absolute;
    width: ${SKINNY_SLIDE_WIDTH}px;
    height: ${DRAFT_PICK_SLIDE_HEIGHT}px;

    ${({ $isLeftControl }) =>
        $isLeftControl
            ? css`
                  left: 0;
              `
            : css`
                  right: 0;
              `}
`;

export const PrevNavControl = styled(Control)`
    border: none;
    ${({ theme }) => BaseStyle.Mixins.utility.boxShadow(60, theme.Surface.primary, [BaseStyle.StyleDirections.right])}
`;

export const NextNavControl = styled(Control)`
    border: none;
    ${({ theme }) => BaseStyle.Mixins.utility.boxShadow(60, theme.Surface.primary, [BaseStyle.StyleDirections.left])}
`;

export const LinksRow = styled.div`
    ${BaseStyle.Mixins.gaps.medium}

    display: flex;
    flex-direction: row;
    align-items: center;
    border-top: 1px solid ${({ theme }) => theme.Surface.border};
    padding: 8px 16px;

    > ${DraftLink} {
        flex: 1;
    }
`;
